import PropTypes from 'prop-types';
import React from 'react';

const Pane = props => <div className="ui-tabs_pane">{ props.children }</div>;

Pane.propTypes = {
	label: PropTypes.string.isRequired,
	index: PropTypes.string.isRequired,
	children: PropTypes.element,
	isVisible: PropTypes.bool
};

Pane.defaultProps = {
	isVisible: true
};

export default Pane;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/shared/tabs/pane.js